import { render, staticRenderFns } from "./RealEstateTypeDropDown.vue?vue&type=template&id=23147020&"
import script from "./RealEstateTypeDropDown.vue?vue&type=script&lang=js&"
export * from "./RealEstateTypeDropDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports